$xxsm: var(--cxy-icon-size-xxsm);
$xsm: var(--cxy-icon-size-xsm);
$sm: var(--cxy-icon-size-sm);
$md: var(--cxy-icon-size-md);
$lg: var(--cxy-icon-size-lg);
$xlg: var(--cxy-icon-size-xlg);
$xxlg: var(--cxy-icon-size-xxlg);
$xxxlg: var(--cxy-icon-size-xxxlg);

[data-fpsm-theme='oddschecker'],
[data-fpsm-theme='plus'],
[data-fpsm-theme='whoscored'],
[data-fpsm-theme='gazzetta'] {
  --icon-grey: initial;
}

[data-fpsm-theme='whoscored'] {
  --icon-grey: var(--cxy-color-content-subtle);
}

[data-fpsm-theme='gazzetta'] {
  --icon-grey: #8a8a8a;
}

.icon {
  opacity: var(--opacity, 1);
}

.size--xxsm {
  height: $xxsm;
  width: $xxsm;
}

.size--xsm {
  height: $xsm;
  width: $xsm;
}

.size--sm {
  height: $sm;
  width: $sm;
}

.size--md {
  height: $md;
  width: $md;
}

.size--lg {
  height: $lg;
  width: $lg;
}

.size--xlg {
  height: $xlg;
  width: $xlg;
}

.size--xxlg {
  height: $xxlg;
  width: $xxlg;
}

.size--xxxlg {
  height: $xxxlg;
  width: $xxxlg;
}

.color--black {
  color: var(--cxy-color-icon-black);
}

.color--white {
  color: var(--cxy-color-content-on-inverse);
}

.color--green {
  color: var(--cxy-color-brand);
}

.color--blue {
  color: var(--cxy-color-icon-primary-default-hover);
}

.color--grey {
  color: var(--icon-grey, #e5e5e5);
}
